/**
 * AdminSetup — PALACIO DA SABEDORIA
 *
 * Garante que o utilizador Admin existe na BD ao iniciar a app.
 * Totalmente independente do Lumi Auth. Sem OTP.
 */
import { useEffect } from 'react'
import { lumi } from '@/lib/lumi'

const SETUP_KEY = 'rcf_admin_v10'

export default function AdminSetup() {
  useEffect(() => {
    if (sessionStorage.getItem(SETUP_KEY)) return
    ensureAdmin()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return null
}

async function ensureAdmin() {
  try {
    await lumi.functions.invoke('createAdminUser', {
      method: 'POST',
      body: { action: 'seed' },
    })
    sessionStorage.setItem(SETUP_KEY, '1')
  } catch {
    // Silencioso — o admin pode já existir ou a função estar a inicializar
  }
}
